var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlipayhk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 290 65.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .alipay-1 {\n        fill: #060606;\n      }\n\n      .alipay-2 {\n        fill: #2d9dd8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "alipay-1",
    d: "M107.09,50.95v13.48s-.54.59-.59.59h-10.75V17.15c0-.26,1.26-1.26,1.77-1.36,1.09-.21,7.5-.22,8.59,0,1.79.34.36,2.82,1.56,2.34,1.64-.66,2.93-2.06,5.19-2.62,9.35-2.31,18.43,4.22,19.25,13.75,1.35,15.58-9.71,25.61-25.03,21.71ZM113.26,21.33c-2.63.26-4.92,2.5-6.48,4.49.7,6.2-3.43,21.99,6.76,21.65,4.33-.14,6.49-5.93,6.83-9.62.43-4.67.03-17.24-7.11-16.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alipay-1",
    d: "M0,50.95L22.66,4.34c1.41-1.57,3.41-.98,5.3-1.1l22.46,47.71h-11.53c-1.35-1.17-3.16-7.38-4.37-7.74-6.71.38-14.47-.76-21.05-.1-.36.04-.72,0-1.07.1-1.16.35-3.59,6.3-4.18,7.74H0ZM33.22,39.62l-9.77-20.71-9.78,20.71h19.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alipay-1",
    d: "M168.84,50.95c-3.21-.25-6.84.32-9.99.02-.87-.08-1.37-.75-1.92-.78-1.11-.06-4.92,1.46-7.03,1.55-17.79.75-18.43-24.32-1.18-25.03,2.89-.12,6.31,1.1,9.01.41.31-.43-.17-4.04-.4-4.74-1.92-5.99-16.17-1.54-17-2.35-.13-.12-.53-3.36-.4-3.49,7.4-1.86,22.52-3.16,27.52,3.92.23.32,1.39,2.37,1.39,2.52v27.94ZM151.54,31.9c-9.77,1.66-8.32,16.58,2.94,14.67,1.03-.18,3.02-1.07,3.33-2.14.26-.9.28-9.77.07-10.85-.41-2.13-4.65-1.96-6.35-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alipay-1",
    d: "M183.69,15l11.53,21.5,9.11-19.82c.16-.52,1.47-1.68,1.84-1.68h6.45c-1.64,4.91-4.01,9.62-6.18,14.33-3.48,7.55-6.98,15.54-10.68,22.94-1.57,3.14-2.75,6.22-5.68,8.39-3.39,2.52-8.54,3.63-12.64,2.8v-5.86c7.23.59,10.08-2.69,12.03-9.12l-17.5-33.48h11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alipay-2",
    d: "M231.37,15.39v14.46h12.51v-13.87s.54-.59.59-.59h6.84v35.96h-6.84s-.59-.54-.59-.59v-14.27h-12.51v14.85h-7.43V15.39h7.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alipay-2",
    d: "M267.33,15.39v14.85c.91.02,1.58-.96,2.16-1.56,3.82-3.97,7.17-9.18,10.94-13.29h8.79l-12.07,14.32,12.85,21.63h-8.01c-.94,0-8.07-14.41-9.77-16.02l-4.88,5.27v10.75h-7.04V15.39h7.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alipay-1",
    d: "M66.44,3.27v47.68h-11.33V5.42c0-.31,1.06-2.15,1.37-2.15h9.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alipay-1",
    d: "M86.77,15.78v35.18h-10.94V17.15c0-.1,1.27-1.37,1.37-1.37h9.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alipay-2",
    d: "M76.74,1.84c5.81-5.75,15.04,3.42,7.96,7.76-6.17,3.79-12.35-3.42-7.96-7.76Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlipayhk);
export default __webpack_public_path__ + "static/media/Alipayhk.26e54b97b967561f4395b49cb1ba53d8.svg";
export { ForwardRef as ReactComponent };